import {Alert, Button} from '@hm/fundamental'
import {mdiCogOutline} from '@mdi/js'

import {useKilns} from '@refra/modules/common/providers'
import {getKilnSetupRedirectUrl} from '@refra/modules/common/utils'
import {useUrlParam} from '@refra/modules/routing/hooks'

interface KilnValidationErrorAlertProps {
  description: string
  buttonText: string
  settingsTab: 'layout' | 'heatZones' | 'drillingZones'
}

export const KilnValidationErrorAlert: React.FC<KilnValidationErrorAlertProps> = ({
  description,
  buttonText,
  settingsTab
}) => {
  const plantId = useUrlParam('plantCode')
  const {selectedKiln} = useKilns()

  // HCP-98946: fix the alert component to support action button at the end of Alert in the fundamental library
  return (
    <Alert variant="info" data-cy={`incomplete_setup_alert_${settingsTab}`}>
      <div className="flex items-center justify-between w-[420px]">
        {description}
        <Button
          iconPrefix={mdiCogOutline}
          onClick={() =>
            (window.location.href = getKilnSetupRedirectUrl(
              plantId,
              selectedKiln.upmId,
              settingsTab
            ))
          }
          data-cy={`incomplete_setup_button_${settingsTab}`}
        >
          {buttonText}
        </Button>
      </div>
    </Alert>
  )
}
